import { Instance, types } from 'mobx-state-tree';

export const ExerciseModel = types.model('ExerciseModel', {
  _id: types.identifier,
  humanReadableId: types.maybeNull(types.string),
  doneToday: types.maybeNull(types.boolean),
  completed: types.maybeNull(types.boolean),
  title: types.maybeNull(types.string),
  shortDescription: types.maybeNull(types.string),
  longDescription: types.maybeNull(types.string),
  reinforcementMessage: types.maybeNull(types.string),
  estimatedTime: types.maybeNull(types.string),
  image: types.maybeNull(types.string),
  myExerciceId: types.maybeNull(types.string),
  language: types.maybeNull(types.string),
  designSystemColor:types.maybeNull(types.string),
  path: types.maybeNull(types.string),
});

export type IExerciseModel = Instance<typeof ExerciseModel>;

